var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChartBar = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 20.4c-.495 0-.919-.176-1.271-.529a1.733 1.733 0 01-.529-1.27v-15h1.8v15h15v1.8h-15zm1.2-3V9h3.6v8.4H6.6zm4.8 0V4.8H15v12.6h-3.6zm4.8 0v-4.8h3.6v4.8h-3.6z"
  })));
};
export default SvgChartBar;